import { render, staticRenderFns } from "./ApplicantProfileTeamNotes.vue?vue&type=template&id=755d7ae1"
import script from "./ApplicantProfileTeamNotes.vue?vue&type=script&lang=js"
export * from "./ApplicantProfileTeamNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports